import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import { injectIntl, FormattedMessage } from 'react-intl';
import { useFlags } from 'launchdarkly-react-client-sdk';
import enums from '../../constants/defaultEnums';
import formUtils from '../../utils/formUtils';
import CustomCheckboxField from '../../components/CustomCheckboxField';

function ScreenConsent() {
  const language = 'en';


  return (
    true ? (
      <div>
        <h3 className='mb-2 personal ui-h3-heavy'>
          <FormattedMessage
 id="2TSRZn" description="screeningConsent"
            defaultMessage="Screening Consent"
          />
        </h3>
        <div className='mb-5'>
          <p>
            <FormattedMessage
 id="vb9iJW" description="screeningConsent2"
              defaultMessage="We use this screening to understand needs our [members / patients / clients] have which could interfere with good health. We may share your answers with your other healthcare providers, and with your health plan and social services organizations, so they can determine if you qualify for any free non-medical services that could be helpful. Please check this box if you agree to continue. You can choose not to answer this survey, but we can only check for services if you do answer."
            />
          </p>
        </div>        
        <div className='mb-5'>
          <p>
            <FormattedMessage
 id="2DZwiH" description="screeningConsent3"
              defaultMessage="You can choose to be screened later and may be eligible for extra services at that time. None of this will affect your ongoing Medicaid eligibility."
            />
          </p>
        </div>
        <CustomCheckboxField
          name="first_name"
          label={<FormattedMessage
 id="4EswtC" description="screeningConsent4"
                    defaultMessage="I consent to sharing screening information. *"
                  />}
          id="uu_screening_consent_check"
          required
          language={language}
        />
      </div>
    ) : ''
  );
}

export default injectIntl(ScreenConsent);
